import { render, staticRenderFns } from "./UserQueryCard.vue?vue&type=template&id=b2e5c508&"
import script from "./UserQueryCard.vue?vue&type=script&lang=js&"
export * from "./UserQueryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports